import { Link } from "react-router-dom";
import "../App.css";
import login from "../assets/images/CrewIOS/iphone-login-6.5.jpg";
import home from "../assets/images/CrewIOS/iphone-home-6.5.jpg";
import flight from "../assets/images/CrewIOS/iphone-flight-6.5.jpg";

const page = () => {
  return (
    <div>
      <div className="menu-container">
        <div className="menu">
          <div className="date">Home</div>
          <div className="signup">{/* Sign Up */}</div>
          <div className="login">{/* Login */}</div>
        </div>
      </div>
      <main className="main-container">
        <div className="header">
          <h6>Air Technology Developer</h6>
          <h6>omidabbaspour1020@gmail.com</h6>
        </div>
        <div className="main">
          <div className="title">
            <h6>Crew</h6>
          </div>
          <div className="item">
            <img src={login} className="main-img" alt="Tam-Android" />
          </div>
          <div className="item">
            <img src={home} className="main-img" alt="Tam-Android" />
          </div>
          <div className="item">
            <img src={flight} className="main-img" alt="Tam-Android" />
          </div>
        </div>
      </main>
      <div class="footer">
        <div class="footer-item footer-one">
          <ul class="footer-menu">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/privacyPolicy">Privacy Policy</Link>
            </li>
            <li>
              <Link to="/contactus">Contact Us</Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default page;
